export class ProcessTrackerSideNavigationTree {
    static topItems = (parentId: string) => [
        ProcessTrackerSideNavigationTree.getTopPTItem(parentId, 1, 'PT_FRP', 'Financial Report Publishing', 'frp'),
        ProcessTrackerSideNavigationTree.getTopPTItem(parentId, 2, 'PT_MRG', 'Management Report Generation', 'mrg'),
        ProcessTrackerSideNavigationTree.getTopPTItem(
            parentId,
            3,
            'PT_SG',
            'Annual Statement Generation Process',
            'sg'
        ),
        ProcessTrackerSideNavigationTree.getTopPTItem(parentId, 4, 'PT_CO', 'Annual Coupon Order', 'co'),
        ProcessTrackerSideNavigationTree.getTopPTItem(parentId, 5, 'PT_BP', 'Annual Budget Preparation', 'bp'),
        ProcessTrackerSideNavigationTree.getTopPTItem(parentId, 6, 'PT_ST', 'Annual State Tax Return Filing', 'st'),
        ProcessTrackerSideNavigationTree.getTopPTItem(parentId, 7, 'PT_FT', 'Annual Federal Tax Return Filing', 'ft')
    ];

    static communityItems = (parentId: string) => [
        ProcessTrackerSideNavigationTree.getCommunityPTItem(
            parentId,
            1,
            'PT_FRP',
            'Financial Report Publishing',
            'frp'
        ),
        ProcessTrackerSideNavigationTree.getCommunityPTItem(
            parentId,
            2,
            'PT_MRG',
            'Management Report Generation',
            'mrg'
        ),
        ProcessTrackerSideNavigationTree.getCommunityPTItem(
            parentId,
            3,
            'PT_SG',
            'Annual Statement Generation Process',
            'sg'
        ),
        ProcessTrackerSideNavigationTree.getCommunityPTItem(parentId, 4, 'PT_CO', 'Annual Coupon Order', 'co'),
        ProcessTrackerSideNavigationTree.getCommunityPTItem(parentId, 5, 'PT_BP', 'Annual Budget Preparation', 'bp'),
        ProcessTrackerSideNavigationTree.getCommunityPTItem(
            parentId,
            6,
            'PT_ST',
            'Annual State Tax Return Filing',
            'st'
        ),
        ProcessTrackerSideNavigationTree.getCommunityPTItem(
            parentId,
            7,
            'PT_FT',
            'Annual Federal Tax Return Filing',
            'ft'
        )
    ];

    static getTopPTItem = (parentId: string, childId: number, name: string, text: string, path: string) => {
        return ProcessTrackerSideNavigationTree.getPTItem(
            parentId,
            childId,
            name,
            text,
            `/my-work/process-tracker/${path}`
        );
    };

    static getCommunityPTItem = (parentId: string, childId: number, name: string, text: string, path: string) => {
        return ProcessTrackerSideNavigationTree.getPTItem(
            parentId,
            childId,
            name,
            text,
            `/community/:communityId/my-work/process-tracker/${path}`
        );
    };

    static getPTItem = (parentId: string, childId: number, name: string, text: string, path: string) => {
        return {
            id: `${parentId}_${childId}`,
            parentId,
            name,
            path,
            icon: '',
            text,
            tooltip: text,
            items: []
        };
    };
}
